import * as Handlebars from 'handlebars';

const compiledHandlebarsTemplates = {};

const defaultHelpers = [
  {
    name: 'ifEquals',
    function: `function(arg1, arg2, options) {return (arg1 === arg2) ? options.fn(this) : options.inverse(this);}`
  },
  {
    name: 'ifNotEquals',
    function: `function(arg1, arg2, options) {return (arg1 !== arg2) ? options.fn(this) : options.inverse(this);}`
  },
  {
    name: 'switch',
    function: `function(value, options) {this.switch_value = value;this.switch_break = false; return options.fn(this);}`
  },
  {
    name: 'case',
    function: `function(value, options) {if (value === this.switch_value) {this.switch_break = true;return options.fn(this);}}`
  },
  {
    name: 'default',
    function: `function(value, options) {if (this.switch_break === false) {return value;}}`
  },
  {
    name: 'dateFormat',
    function: `function(date, format, options) { return moment(date).format(format); }`
  },
  {
    name: 'dateAdd',
    function: `function(date, amount, what, options) { return moment(date).add(amount, what).format(); }`
  },
  {
    name: 'dateFromNow',
    function: `function(date, options) { return moment(date).fromNow(); }`
  },
  {
    name: 'dateToNow',
    function: `function(date, options) { return moment(date).toNow(); }`
  },
  {
    name: 'dateCalendar',
    function: `function(date, options) { return moment(date).calendar(); }`
  }
];

const sclHandlebars = (() => {
    return{
        initHandlebars(helpers) {
            /*
            // Adding some standard helpers
            // Comparison
            Handlebars.registerHelper('ifEquals', function(arg1, arg2, options) {
                return (arg1 === arg2) ? options.fn(this) : options.inverse(this);
            });
            Handlebars.registerHelper('ifNotEquals', function(arg1, arg2, options) {
                return (arg1 !== arg2) ? options.fn(this) : options.inverse(this);
            });
            Handlebars.registerHelper('switch', function(value, options) {
                let that: any = {};
                that.switch_value = value;
                that.switch_break = false;
                return options.fn(that);
            });
            Handlebars.registerHelper('case', function(value, options) {
            if (value === this.switch_value) {
                this.switch_break = true;
                return options.fn(this);
            }
            });
            Handlebars.registerHelper('default', function(value, options) {
            if (this.switch_break === false) {
                return value;
            }
            });
            // Date handling
            Handlebars.registerHelper('dateFormat', function(date, format, options) { return moment(date).format(format); });
            Handlebars.registerHelper('dateAdd', function(date, amount, what, options) { return moment(date).add(amount, what).format(); });
            Handlebars.registerHelper('dateFromNow', function(date, options) { return moment(date).fromNow(); });
            Handlebars.registerHelper('dateToNow', function(date, options) { return moment(date).toNow(); });
            Handlebars.registerHelper('dateCalendar', function(date, options) { return moment(date).calendar(); }); */

            for (let i = 0; i < defaultHelpers.length; i++) {
              if (typeof defaultHelpers[i].name === 'string' && typeof defaultHelpers[i].function === 'string') {
                const defaultHelps = new Function('return ' + defaultHelpers[i].function)();
                Handlebars.registerHelper(defaultHelpers[i].name, defaultHelps);
              }
            }

            // If component has helpers defined add them in too
            if (typeof helpers !== 'undefined' && helpers !== null ) {
                for (const helper of helpers) {
                    if (typeof helper.name === 'string' && typeof helper.function === 'string') {
                        let helpFunc = helper.function;
                        if (typeof helpFunc === 'string') {
                            helpFunc = new Function('return ' + helpFunc)();
                        }

                        Handlebars.registerHelper(helper.name, helpFunc);
                    }
                }
            }
        },

        defaultHelpers() {
          return defaultHelpers;
        },
        checkRegistedHelpers(helpers) {
            if (!helpers) { return; }
            // console.log('%c ibefore checkRegistedHelpers : ', 'color:blue');
            // console.log(Handlebars.helpers);
            let isRegistered = true;
            for (let i = 0; i < helpers.length ; i++) {
                if (typeof helpers[i].name === 'string' && typeof helpers[i].function === 'string') {
                    if (!(helpers[i].name in Handlebars.helpers)) {
                        isRegistered = false;
                        break;
                    }
                }
            }
            if (!isRegistered) {
                sclHandlebars.initHandlebars(helpers);
            }
        },
        // throws an error instead of returning null
        processHandlebarsV2(handlebarsString, data, handlebarsContext?: any, helpers?, contextParams?, options?) {
            if (handlebarsString == null || typeof handlebarsString === 'undefined') {
                return '';
            }
            if ((typeof handlebarsString === 'string' || handlebarsString instanceof String)
            && (handlebarsString.indexOf('{{') < 0)) {
                return handlebarsString;
            }


            sclHandlebars.checkRegistedHelpers(helpers);
            let hStr;
            if (typeof handlebarsString === 'string') {
                hStr = handlebarsString;
            } else {
                hStr = JSON.stringify(handlebarsString);
            }

            // begin : 14274
            if (!handlebarsContext) {
              handlebarsContext = {};
            }
            const invalidField = ['document', 'doc', 'account', 'tpl', 'componentDefinition'
            , 'results', 'resultsCount', 'resultsIndex', 'result', 'row'];
            if (data) {
                if (Object(data) === data) {// if the second parameter is object has property
                    for (const f in data) {
                        if (f === 'queryResultDocument') {
                            handlebarsContext.row = data[f];
                            handlebarsContext.result = data[f];
                            for (const j in data[f]) {
                                if (data[f].hasOwnProperty(j)) {
                                    if (invalidField.indexOf(j) > -1) {
                                        console.log('Handlebars Context Error: the field ' + j
                                        + ' is already present in document documentId so could not be set.'
                                        + ' It\'s values will NOT be available to handlebars expressions.'
                                        + ' Please advise your Application Developer to not use this field name if possible');
                                        continue;
                                    }
                                    handlebarsContext[j] = data[f][j];
                                }
                            }

                        } else {
                            if (handlebarsContext.hasOwnProperty(f)) {
                                console.log('error : handlebarsString = ' + handlebarsString
                                + '\n\t data = ' + JSON.stringify(data)
                                + '\n\t handlebarsContext = ' + JSON.stringify(handlebarsContext)
                                + '\n\t helpers = ' + JSON.stringify(helpers));
                                // console.log('Handlebars Context Error: the field ' + f
                                //  + ' is already present in document documentId so could not be set.'
                                //  + ' It\'s values will NOT be available to handlebars expressions.'
                                //  + ' Please advise your Application Developer to not use this field name if possible');
                                continue;
                            }
                            handlebarsContext[f] = data[f];
                        }
                    }
                } else {
                    console.log('Handlebars Context Error: object ' + data + ' wasn\'t passed in and the parameters is being ignored');
                }
            }
            // end : 14274
            // console.log('handlebarsContext = ' + JSON.stringify(handlebarsContext));
            let result = null;
            try {
                let template;

                if (options?.handlebarsTemplateName && contextParams) {
                    // cache the template so it can be used in subsequent runs
                    const templateKey = `${contextParams?.tpl?.documentId}_${contextParams?.tplItem?.name}_${options.handlebarsTemplateName}`;
                    if (compiledHandlebarsTemplates[templateKey]) {
                        template = compiledHandlebarsTemplates[templateKey];
                    } else {
                        template = Handlebars.compile(hStr);
                        compiledHandlebarsTemplates[templateKey] = template;
                    }
                } else {
                    template = Handlebars.compile(hStr);
                }

                result = template(handlebarsContext);
            } catch (err) {
                err.hStr = hStr;
                throw err;
            }
            return result;
        },
        // backward compatibility purposes because it's still used in a lot of areas: returns an null object
        processHandlebars(handlebarsString, data, handlebarsContext?: any, helpers?, contextParams?, options?) {
          let result = null;
          try {
            if (contextParams) {
                if (!handlebarsContext) {
                    handlebarsContext = {};
                }
                handlebarsContext.document = contextParams.doc; // the fields from the current document
                handlebarsContext.doc = contextParams.doc; // a duplicate for compatibility of document
                handlebarsContext.account = contextParams.account; // the account document from scope
                handlebarsContext.tpl = contextParams.tpl; // the template for the current document
                handlebarsContext.tplItem = contextParams.tplItem; // the current components configuration details
            }

            result = sclHandlebars.processHandlebarsV2(handlebarsString, data, handlebarsContext, helpers, contextParams, options);
          } catch (err) {
            console.error(err);
          }
          return result;
        },
        processIntHandlebars(handlebarsString, data, handlebarsContext?: any, helpers?, contextParams?, options?) {
            const hStr = sclHandlebars.processHandlebars(handlebarsString, data, handlebarsContext, helpers, contextParams, options);
            if (hStr) {
                return parseInt( hStr, 0 );
            } else { return 0; }
        },
        processFloatHandlebars(handlebarsString, data, handlebarsContext?: any, helpers?, contextParams?, options?) {
            const hStr = sclHandlebars.processHandlebars(handlebarsString, data, handlebarsContext, helpers, contextParams, options);
            if (hStr) {
                return parseFloat( hStr );
            } else { return 0; }
        },
        processBooleanHandlebars(handlebarsString, data, handlebarsContext?: any, helpers?, contextParams?, options?) {
            return  sclHandlebars.processHandlebars(handlebarsString, data, handlebarsContext, helpers, contextParams, options) === 'true';
        },
        processArrayHandlebars(handlebarsString, data, handlebarsContext?: any, helpers?, contextParams?, options?) {
            let hStr = sclHandlebars.processHandlebars(handlebarsString, data, handlebarsContext, helpers, contextParams, options);
            if (hStr) {
                try {
                    let arr = [];

                    if (typeof hStr === 'string' && hStr.indexOf(',') > -1) {
                        if (hStr.indexOf('[') > -1) {
                            hStr = hStr.replace('[', '');
                        }
                        if (hStr.indexOf(']') > -1) {
                            hStr = hStr.replace(']', '');
                        }
                        const s = hStr.split(',');
                        if (s?.length === 2
                             && (!isNaN(Number(s[0].trim())) && !isNaN(parseFloat(s[0].trim())))
                             && (!isNaN(Number(s[1].trim())) && !isNaN(parseFloat(s[1].trim())))) {
                            arr = [parseFloat(s[0].trim()), parseFloat(s[1].trim())];
                        }
                    } else {
                        const obj = JSON.parse( hStr );
                        for (const i in obj) {
                            if (obj.hasOwnProperty(i)) {
                                arr.push(obj[i]);
                            }
                        }
                    }
                    return arr;
                } catch (err) {
                    return null;
                }
            } else {
                return null;
            }
        }
    };
})();

export { sclHandlebars };
